import React, { useEffect, useState } from 'react'
import { useTranslation }                         from 'react-i18next'
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
}                                 from '@mui/material'
import AlertSimpleDialog          from '../../components/alert-simple-dialog'
import { useApi }                 from '../../utils/api'
import { useNavigate, useParams } from 'react-router-dom'
import { useSnackbar }            from 'notistack'
import ShortFormControl           from '../../components/short-form-control'

export default function CategoryPage() {

  const api = useApi()
  const navigate = useNavigate()
  const { categoryId } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const [values, setValues] = useState({
    uid: '',
    title: '',
    note: '',
    orangeSrvId: '',
  })
  const [shownDeleteDialog, setShownDeleteDialog] = useState(false)

  useEffect(() => {
    (async () => {
      if (!isNaN(categoryId)) {
        let category = await api.category.detail(categoryId).catch(() => ({}))
        setValues({
          ...category,
          uid: category.uid ?? '',
        })
      }
    })()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId])

  const handleCloseDeleteDialog = (result) => {
    setShownDeleteDialog(false)
    if (result) {
      api.category.delete(categoryId).then(() => {
        enqueueSnackbar(t('Category deleted'), {
          variant: 'success'
        })
        navigate('/dashboard/categories')
      }).catch(error => {
        enqueueSnackbar(t('Failed to delete category'), {
          variant: 'error'
        })
      })
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    let data = {
      ...values,
      uid: values.uid ? values.uid : null,
    }
    try {
      let category = await api.category.save(data)
      navigate(`/dashboard/category/${category.id}`)
      enqueueSnackbar(t('Category saved'), {
        variant: 'success'
      })
    } catch (e) {
      enqueueSnackbar(t('Failed to save category'), {
        variant: 'error'
      })
    }
  }

  const handleChange = (prop) => (event) => {
    handleChangeDirect(prop, event.target.value)
  }

  const handleChangeDirect = (prop, value) => {
    setValues({ ...values, [prop]: value });
  }

  return (
    <Container component="main">
      <Grid component={'form'} onSubmit={onSubmit} item xs={12}>
        <Paper sx={{ p: 2, width: '100%' }}>
          <Grid container sx={{ width: '100%' }} spacing={2}>
            <Grid item xs={12}>
              <ShortFormControl
                name={'uid'}
                title={t('UID')}
                value={values.uid}
                handleChange={handleChange} />
              <span>{t('category-uid-hint')}</span>
            </Grid>
            <Grid item xs={12}>
              <ShortFormControl
                name={'title'}
                title={t('Title')}
                value={values.title}
                handleChange={handleChange} />
            </Grid>
            <Grid item xs={12}>
              <ShortFormControl
                name={'note'}
                title={t('Note')}
                value={values.note}
                handleChange={handleChange} />
            </Grid>
            <Grid item xs={12}>
              <ShortFormControl
                name={'orangeSrvId'}
                title={'Orange srvId'}
                value={values.orangeSrvId}
                handleChange={handleChange} />
              <span>Orange: Parkovné: MXPARK, Hlasovanie: MXVOTE, Spotrebiteľské súťaže: MXVOTEFRAUD</span>
            </Grid>
          </Grid>
        </Paper>
        <Box sx={{ mt: 2, px: 1 }}>
          <Button type={'submit'} variant={'contained'}>{t('Save category')}</Button>
          { !isNaN(categoryId) && (<Button type={'button'} color={'error'} variant={'contained'} sx={{ ml: 2 }} onClick={() => { setShownDeleteDialog(true) }}>{t('Delete')}</Button>) }
        </Box>
      </Grid>
      <AlertSimpleDialog
        title={t('Deleting category')}
        message={t('delete-confirm-msg', { name: values.title })}
        open={shownDeleteDialog}
        onClose={handleCloseDeleteDialog}
      />
    </Container>
  )

}